/**
 * curriculum.json is now stored on S3 in aqua-extended bucket. direct link
 * to Field Observer curriculum folder:
 * https://s3.console.aws.amazon.com/s3/buckets/aqua-extended/gc/picture_this/curriculum/?region=us-west-2&tab=overview
 *
 * This file is to store the curriculum when it is fetched and offer hooks to retrieve the fetched curriculum when needed.
 *
 * Current Curriculums are generated in the Shades of Meaning Content Sheet, link to workbook:
 * https://docs.google.com/spreadsheets/d/1KcNxv2AQbdh48Su14looBeMo8_Iu9ESyoLQli3ehAbQ/edit#gid=0
 */
let curriculum = {};

export const getCurriculum = () => curriculum;
export const setCurriculum = (c) => { curriculum = c; };
